import { generateColorShades } from './utils';

const baseDark = '#091a2b';
const baseDarker = '#0a0a0a';
const baseTextDark = '#dadde0';
const baseTextDarker = '#dadde0';

export interface IColors {
  primary: string;
  accent: string;
  input_background?: string;
  input_text?: string;
  input_placeholder?: string;
  input_border?: string;
  input_border_focus?: string;
  error_red?: string;
  text: string;
  bg_100?: string;
  bg_200?: string;
  bg_300?: string;
  bg_400?: string;
  bg_500?: string;
  bg_600?: string;
  bg_700?: string;
  bg_800?: string;
  bg_900?: string;
  text_100?: string;
  text_200?: string;
  text_300?: string;
  text_400?: string;
  text_500?: string;
  text_600?: string;
  text_700?: string;
  text_800?: string;
  text_900?: string;
}

export const darkColors: IColors = {
  primary: '#00ffff',
  accent: '#36d6ff',
  input_background: '#101c2a',
  input_text: '#e5e5e5',
  input_placeholder: '#d3d9e3',
  error_red: '#ff3e45',
  input_border: '#2f4358',
  input_border_focus: '#00ffff',
  text: '#c9d1d9',
  ...generateColorShades(baseDark, 'bg'),
  ...generateColorShades(baseTextDark, 'text'),
};

export const darkerColors: IColors = {
  primary: '#000000',
  accent: '#c7ced9',
  input_background: '#111216',
  input_text: '#efefef',
  input_placeholder: '#d0d5de',
  error_red: '#ff3e45',
  input_border: '#2b2d34',
  input_border_focus: '#ffffff',
  text: '#dddddd',
  ...generateColorShades(baseDarker, 'bg'),
  ...generateColorShades(baseTextDarker, 'text'),
};

export const Colors = {
  dark: darkColors,
  darker: darkerColors,
};
